import "./AllNotifications.css";
import React, { Fragment, useEffect, useState } from "react";
import AllNotificationsViewModel from "./AllNotificationsViewModel";
import GetSingleClass from "../../../Controllers/Admin/ClassAndCourses/GetSingleClass";
import { db } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import useRealsTimeNotifications from "../../../Controllers/notifications/useRealTimeNotifications";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import GetUser from "../../../Controllers/Users/GetUser";

const AllNotifications = () => {
  const navigate = useNavigate();

  const [CurrentAuth, setCurrentAuth] = useState({});
  const [Notifications] = useRealsTimeNotifications();
  const [NotificationsWithClassesData, setNotificationsWithClassesData] =
    useState([]);

  // Function to fetch data for a single document ID
  const fetchClassData = async (notification) => {
    try {
      const docRef = doc(db, "Classes", notification.ClassID);
      // const Ref = doc(db, "Classes", notification.ClassID);
      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists) {
        // Document exists, retrieve its data
        const docData = docSnapshot.data();
        return { notification, ...docData };
      } else {
        // Document does not exist
        console.log(`Document with ID ${notification.ClassID} does not exist.`);
        return null;
      }
    } catch (error) {
      console.error(
        `Error fetching document with ID ${notification.ClassID}:`,
        error
      );
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchPromises = Notifications?.map((notification) =>
          fetchClassData(notification)
        );
        const results = await Promise.all(fetchPromises);

        let final = results.filter((result) => result !== null);
        console.log("final", final);
        setNotificationsWithClassesData(final);
      } catch (error) {
        console.error("Error fetching multiple documents:", error);
        return [];
      }
    };
    fetchData();
  }, [Notifications]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        if (!user.emailVerified) {
          navigate("/email-verification");
          return;
        }
        const UserData = await GetUser(user?.uid);
        if (UserData?.IsVerified === 0) {
          navigate("/verification-pending");
          return;
        }

        setCurrentAuth(UserData);
      });
    }

    fetchData();
  }, []);

  return (
    <Fragment>
      {CurrentAuth.UserType === "teacher" ? (
        <Fragment>
          {/* <!-- Page Wrapper --> */}
          <div className="page-wrapper notifications-container">
            <div className="content container-fluid">
              {/* <!-- Page Header --> */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">All Notifications</h3>
                    {/* <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Blank Page</li>
                </ul> */}
                  </div>
                </div>
              </div>
              {/* <!-- /Page Header --> */}

              <div className="row">
                {Notifications &&
                  Notifications.map((notification) => {
                    console.log("teacher-notification", notification);
                    return (
                      <div className="col-sm-12 single-notification">
                        <p className="title">{notification?.description}</p>
                        <small className="time">
                          {notification?.course?.createdAt
                            ?.toDate()
                            ?.toLocaleString()}
                        </small>
                        <p className="message">
                          {notification?.course?.CourseName &&
                            "Course name is " +
                              notification?.course?.CourseName}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {/* <!-- /Page Wrapper --> */}
        </Fragment>
      ) : CurrentAuth.UserType === "student" ? (
        <Fragment>
          {/* <!-- Page Wrapper --> */}
          <div className="page-wrapper notifications-container">
            <div className="content container-fluid">
              {/* <!-- Page Header --> */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">All Notifications</h3>
                  </div>
                </div>
              </div>
              {/* <!-- /Page Header --> */}

              <div className="row">
                {Notifications &&
                  Notifications.map((notification) => {
                    console.log("student-notification", notification);
                    return (
                      <div className="col-sm-12 single-notification">
                        <p className="title">{notification?.description}</p>
                        <small className="time">
                          {notification?.course?.createdAt
                            ?.toDate()
                            ?.toLocaleString()}
                        </small>
                        <p className="message">
                          {notification?.course?.CourseName &&
                            "Course name is " +
                              notification?.course?.CourseName}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {/* <!-- /Page Wrapper --> */}
        </Fragment>
      ) : CurrentAuth.UserType === "parent" ? (
        <Fragment>
          {/* <!-- Page Wrapper --> */}
          <div className="page-wrapper notifications-container">
            <div className="content container-fluid">
              {/* <!-- Page Header --> */}
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">All Notifications</h3>
                  </div>
                </div>
              </div>
              {/* <!-- /Page Header --> */}

              <div className="row">
                {NotificationsWithClassesData &&
                  NotificationsWithClassesData.map((item) => {
                    return (
                      <div
                        key={item?.notification.id}
                        className="col-sm-12 single-notification"
                      >
                        <p className="title">
                          {item?.notification.description}
                        </p>
                        <small className="time">
                          {item?.notification.createdAt
                            .toDate()
                            .toLocaleString()}
                        </small>
                        <p className="message">
                          Your child who is in class{" "}
                          <span> {item?.ClassName} </span> was absent today.
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {/* <!-- /Page Wrapper --> */}
        </Fragment>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default AllNotifications;
